import { useWalletService } from 'hooks/api/sales/wallet';
import { createContext, useEffect, useState } from 'react';

export const WalletContext = createContext();
export const useTenantWalletData = () => {
  const { fetchWallets } = useWalletService();
  const [tenant_wallet_list, setTenantWalletList] = useState({});

  useEffect(() => {
    const query_string = `exist=tenant_id&return_only=balance,debt,tenant_id,rate`;
    fetchWallets({ query_string }).then(({ wallets }) => {
      const wallet_by_tenant_id = wallets.reduce(
        (sac, item) => ({
          ...sac,
          [item.tenant_id]: {
            rate: item.rate,
            balance: item.balance ? item.balance.toFixed(2) : 0,
            debt: item.debt && item.debt.amount ? item.debt.amount.toFixed(2) : 0
          }
        }),
        {}
      );
      setTenantWalletList(wallet_by_tenant_id);
    });
  }, []);

  return { tenant_wallet_list };
};
